const ramps = {
  adding_title: "Lege die Verfügbarkeitszeiten und die Länge der Zeitfenster für jede Rampe fest",
  your_ramps: "Deine Rampen",
  names_info: "Achtung! Wenn der Name deiner Rampe länger als fünf Zeichen ist, wird er als Index angezeigt",
  no_ramps_in_warehouse: "Keine Rampen im Lager",
  fill_ramps: "Rampen ausfüllen",
  no_ramps: "Keine Rampen",
  no_ramps_error: "Du musst mindestens eine Rampe hinzufügen",
  filled: "Rampe ausgefüllt",
  empty: "Rampe nicht ausgefüllt",
  error: "Fehler beim Ausfüllen",
  saved: "Änderungen erfolgreich gespeichert.",
  current: "Aktuell ausgewählte Rampe",
  confirmRamps: "Kalender hinzufügen bestätigen",
  adding_ramps_title: "Rampennamen eingeben",
  adding_ramp_title: "Rampennamen eingeben",
  adding_ramps_subtitle:
    "Achtung! Achte darauf, dass die Rampennamen mit den tatsächlichen physischen Rampen in deinem Lager übereinstimmen. Andernfalls können Spediteure die richtige Rampe möglicherweise nicht finden.",
  ramp_number: "Rampennummer",
  ramp_name: "Rampenname",
  ramp: "Rampe",
  ramp_adding: "Rampe hinzufügen",
  ramp_name_error: "Der Rampenname darf nicht leer sein",
  manage_ramps: "Rampen verwalten",
  pick_ramp: "Rampe auswählen",
  pick_ramp_to_accept_monitory: "Wähle die Rampe aus, an der der Spediteur die Avisierung durchführt.",
  no_ramps_for_monitory: "Du hast keine freien Rampen um ",
  no_ramps_for_monitory_2: "Füge Zeitfenster für die Rampe hinzu, um weitere Avisierungen anzunehmen.",
  ramp_delete_confirmation:
    "Bist du sicher, dass du die Rampe löschen möchtest? Alle Kalender und Avisierungen, die damit verbunden sind, werden gelöscht. Möchtest du wirklich fortfahren?",
  errors: {
    empty: "Um einen Kalender hinzuzufügen, musst du jede Rampe ausfüllen",
    error: "Fehlerhaft ausgefüllte Rampen.",
    single_ramp: "Fehlerhafte Rampe",
  },
};

export default ramps;
